<template>
  <div class="modal is-active"
  v-if="$store.state.newRef.open">
    <div class="modal-background"></div>
    <div class="modal-content">
      <div class="box new-ref">

        <div class="field">
          <div class="control has-text-right">
              <label class="radio">
                <input type="radio" v-model="fields.createUser" value="0">
                משתמש קיים
              </label>

              <label class="radio">
                <input type="radio" v-model="fields.createUser" value="1">
                משתמש חדש
              </label>
            </div>
        </div>

        <div class="new-user" v-if="fields.createUser === '1'">
          <h4>פרטי משתמש חדש</h4>
          <div class="field">
            <div class="control">
              <input type="text" class="input"
              v-model="fields.newUser.fullname" placeholder="שם מלא">
            </div>
          </div>

          <div class="field">
            <div class="control">
              <input type="email" class="input"
              v-model="fields.newUser.email" placeholder="אימייל">
            </div>
          </div>

          <div class="field">
            <div class="control">
              <input type="password" class="input"
              v-model="fields.newUser.password" placeholder="סיסמה">
            </div>
          </div>

        </div>

        <div class="field" v-if="fields.createUser === '0'">
          <div class="control">
            <input type="number" class="input"
            v-model="fields.uid" placeholder="מזהה משתמש קיים">
          </div>
        </div>

        <div class="field">
          <div class="control">
            <input type="text" class="input"
            v-model="fields.text" placeholder="טקסט">
          </div>
        </div>

        <div class="field">
          <div class="control has-text-right">
            <label class="checkbox">
              <input type="checkbox" checked v-model="fields.active">
              פעיל
            </label>
          </div>
        </div>

        <div class="buttons">
          <button class="button" @click="close">בטל</button>
          <button class="button is-info" @click="saveRef">שמור</button>
        </div>

      </div>
    </div>
    <button class="modal-close is-large" aria-label="close"
    @click="close"></button>
  </div>
</template>

<script>
export default {
  data(){
    return {
      fields: {
        uid: '',
        text: '',
        active: true,
        createUser: '0',
        newUser: {
          fullname: '',
          email: '',
          password: '',
        }
      }
    }
  },
  props: {
    active: Boolean,
  },
  methods: {
    close(){
      this.$store.commit('openNewRef');
      this.resetWindow();
    },

    saveRef(){
      this.$store.dispatch('saveNewRef', this.fields);
    },
    resetWindow(){
      this.fields.uid = '';
      this.fields.text = '';
      this.fields.active = true;
      this.fields.createUser = '0';
      this.fields.newUser.fullname = '';
      this.fields.newUser.email = '';
      this.fields.newUser.password = '';
    }
  }
}
</script>

<style lang="scss">
.new-ref {
  .buttons {
    justify-content: flex-end;
    .button {
      margin-right: 5px;
    }
  }

  .radio {
    margin-left: 10px;
  }

  .new-user {
    margin-bottom: 0.75rem;
    background-color: lightblue;
    padding: 10px;
  }
}
</style>
